<template>
  <div>
    <el-form ref="form" :model="form" label-width="120px" style="form" :rules="rules">
      
      <el-form-item label="服务类型">
        <el-tree
          ref="tree"
          :data="tableData"
          show-checkbox
          default-expand-all
          node-key="id"
          :default-checked-keys="defaultCheckedKeys"
          :props="defaultProps"
          @check="getCheckedNodes"
        ></el-tree>
      </el-form-item>
      <el-form-item label="服务项目" prop="serviceProjectName">
        <el-input v-model="form.serviceProjectName"></el-input>
      </el-form-item>
      <el-form-item label="费用" prop="costType">
        <el-select v-model="form.costType" placeholder="请选择费用" style="width:38%">
          <el-option label="免费" :value="1"></el-option>
          <el-option label="收费" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-row>
        <el-col :span="11">
          <el-form-item label="收费标准" prop="cost">
            <el-input v-model="form.cost">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="11">
          <el-form-item label="单位" prop="timeType">
            <el-select v-model="form.timeType" placeholder="请选择收费标准" style="width:100%">
              <el-option label="次" value="0"></el-option>
              <el-option label="小时" value="1"></el-option>
              <el-option label="月" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <div style="width:100%;height:10px"></div>
        </el-col>
      </el-row>

      <el-form-item label="项目说明">
        <el-input v-model="form.projextExplain" type="textarea"></el-input>
      </el-form-item>
     
      <el-form-item label="审核说明" v-if="auditShow&&auditState==4">
        <el-input type="textarea" v-model="explains"></el-input>
      </el-form-item>
      <div class="button" v-if="buttonType=='add'">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
      <div class="button" v-if="buttonType=='compile'">
        <el-button type="primary" @click="save">编辑</el-button>
        <el-button type="info" @click="cancel">取消</el-button>
      </div>
    </el-form>
   
  </div>
</template>

<script>
import uploadImgs from "@/component/uploadImgs/index.vue";
import request from "@/utils/request.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import editor_option from "../../../../utils/editorOption.js";
import { quillEditor } from "vue-quill-editor";
import {
  oldManOrganizationServeTypeList,
  getAllChildrenPolicyData,
  helpManagePublicityList,
  helpManagePublicityDelete,
  oldManOrganizationserveProjectEdit,
  oldManOrganizationserveProjectCheck,
  getRecordData
} from "../api/index.js";
import upload from "@/component/componentsP/upImg.vue";
export default {
  components: { uploadImgs, quillEditor, upload },
  props: ["title", "buttonType", "row"],
  data() {
    return {
      form: {},
      editDisable: false,
      uploadUrl: request.defaults.baseURL + "/oneStopUpload/info/uplodfiles",
      tableData: [],
      tableColumn: [
        {
          prop: "name",
          label: "姓名"
        },
        {
          prop: "typeName",
          label: "服务类型名称"
        },
        
        {
          type: "state",
          prop: "state",
          label: "审核状态"
        }
        // {
        //   prop: "nationType",
        //   label: "救助状态"
        // },
      ],
      editorOption: editor_option.editorOption,
      data: [],
      defaultProps: {
        children: "children",
        label: "typeName"
      },
      auditShow: false,
      auditState: 3,
      currentPage1: 1,
      fileList: [],
      typeImg: "",
      defaultCheckedKeys: [],
      rules: {
        serviceTypeName: [{ required: true, message: "请选择服务类型", trigger: "blur" }],
        // startTime: [{ required: true, message: "请输入标题", trigger: "blur" }],
        serviceProjectName: [
          { required: true, message: "请填写服务项目", trigger: "blur" }
        ],
        costType: [
          { required: true, message: "请选择费用", trigger: "blur" }
        ],
        cost: [{ required: true, message: "请选择收费标准单位", trigger: "blur" }],
        timeType: [{ required: true, message: "请选择收费标准", trigger: "blur" }],
        
      },
      tableData: [], //
      totalHome: "",
      currentPageHome: "",
      selectChildrenList: [],
      tableColumnListList: [],
      selectVisible: false,
      pageNo: 1,
      pageSize: 10,
      total: 1,
      pageNo1: 1,
      pageSize1: 5,
      total1: 1,
      currentPage: 1,
      treeData: {} //选中的树
    };
  },
  methods: {
    //保存按钮
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$set(
            this.form,
            "serviceTypeId",
            this.treeData.id
          );
           this.$set(this.form, "cost", Number(this.form.cost));
           this.$set(this.form, "state", 1);
          // this.$emit("save", this.form, "保存");
          oldManOrganizationserveProjectEdit(this.form).then(res => {
            this.$message({
              type: "success",
              message: "保存成功"
            });
            this.$emit("cancel");
          });
        }
      });
      // this.$set(this.form,'homePhoto',this.fileListString[0])
      // this.$set(this.form,'longitude','111,111')
      // this.$set(this.form,'homePhoto','111,211')
    },
    //编辑
    compile() {
      this.$refs.form.validate(valid => {
        if (valid) {
         
          if (!this.treeData || Object.keys(this.treeData).length == 0) {
            this.$message({
              type: "warning",
              message: "请选择服务类型"
            });
            return false;
          }
          this.$set(this.form, "serviceTypeId", this.treeData.id);
          this.$set(this.form, "state", 1);
          // this.$set(this.form, "auditStatus", 0);
          this.$emit("save", this.form, "编辑");
        }
      });
    },
    //提交
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.treeData || Object.keys(this.treeData).length == 0) {
            this.$message({
              type: "warning",
              message: "请选择信息分类"
            });
            return false;
          }
          this.$set(this.form, "childrenPolicyTypeId", this.treeData.id);
          this.$set(this.form, "auditStatus", 1);
          this.$emit("save", this.form, "提交");
        }
      });
    },
    //取消
    cancel() {
      this.$emit("cancel");
    },
    //回写拿到数据
    getAllChildrenPolicyDataAPI(e) {
      oldManOrganizationserveProjectCheck(e).then(res => {
        console.log("回写数据", res.content);
        this.form = res.content;
        if (res.content.enclosure) {
          let arr = res.content.enclosure.split(";");
          arr.pop();
          this.fileList = arr.map(item => {
            return {
              path: item,
              name: item
            };
          });
          this.typeImg = "compile";
        }

        console.log(res.content.childrenPolicyTypeId);

        this.defaultCheckedKeys = [res.content.serviceTypeId];
        this.treeData = { id: res.content.serviceTypeId };
      });
    },
    //拿到政策类型
    getAllChildrenPolicyClassifyListAPI(e) {
      oldManOrganizationServeTypeList(e).then(res => {
        console.log("", res.content);
        this.data = res.content;
      });
    },
    //信息分类
    getCheckedNodes(e, data, form) {
      this.$refs.tree.setCheckedKeys([]);
      this.$refs.tree.setCheckedKeys([e.id]);
       console.log("e", e);
       this.treeData = e;
    },
    //审核
    audit() {
      this.$set(this.form, "auditStatus", this.auditState);
      console.log("auditStatus", this.auditState);
      this.$emit("save", this.form, "审核");
    },
    successImg(e) {
      this.fileList = e;
    },

    deleteImg(e) {
      this.fileList = e;
    },
    //选择政策分类
    handleSelectionChange(val) {
      console.log("val", val);
      this.selectChildrenHome = val;
      // if (val && val.length > 0) {
      //   this.$refs.multipleTable.clearSelection();
      //   this.$refs.multipleTable.toggleRowSelection(val[val.length - 1], true);
      //   this.selectChildrenHome = [val[val.length - 1]];
      // } else {
      //   this.selectChildrenHome = [];
      // }
      // this.childrenShow = true;
    },
    //点击选择政策分类全选按钮
    changeAll(e) {
      console.log("e", e);
      this.selectChildrenHome = e;
    },
    //政策分类每页请求数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.helpManagePolicyTypeListAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //政策分类请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.helpManagePolicyTypeListAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //政策分类每页请求数据
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.helpManagePolicyTypeListAPI1();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //政策分类请求第几数据
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.helpManagePolicyTypeListAPI1();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //选择政策分类
    add() {
      this.selectVisible = true;
      this.helpManagePolicyTypeListAPI();
    },
    //拿到服务分类的列表
    helpManagePolicyTypeListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      oldManOrganizationServeTypeList(params).then(res => {
        this.tableData = res.content;
        this.total = res.content.count;
      });
    },
    // //拿到政策分类的列表
    // helpManagePolicyTypeListAPI1(e) {

    //   let params = Object.assign({}, e, {
    //     pageNo: this.pageNo1,
    //     pageSize: this.pageSize1,
    //     publicityId: this.row.id
    //   });
    //   oldManOrganizationServeTypeList(params).then(res => {
    //     this.tableData = res.content.list;
    //     this.total = res.content.count;
    //   });
    // },
    sure() {
      this.tableColumnListList = this.selectChildrenHome;
      this.selectVisible = false;
    },
    //移除选择的政策分类
    remove(e) {
      let index = this.tableColumnListList.findIndex(item => item.id == e.id);
      this.tableColumnListList.splice(index, 1);
    },
    //回写拿到数据
    // helpManagePolicyTypeListAPI1(e) {
    //   let params = Object.assign({}, e, {
    //     pageNo: this.pageNo1,
    //     pageSize: this.pageSize1,
    //     publicityId: this.row.id
    //   });
    //   getRecordData(params).then(res => {
    //     console.log("回写数据", res.content);
    //     this.tableColumnListList = res.content.list;
    //   });
    // }
  },
  created() {
    console.log(this.buttonType);
    this.helpManagePolicyTypeListAPI()
    //根据this.buttonType的值来判断点的是什么按钮
    if (this.buttonType == "check" || this.buttonType == "compile") {
      this.getAllChildrenPolicyDataAPI({ id: this.row.id });
    }
  }
};
</script>

<style scoped>
.left {
  width: 44%;
  display: inline-block;
}
.right {
  width: 45%;
  display: inline-block;
  float: left;
}
.flex {
  display: flex;
}
.itemSelect {
  width: 30%;
}
.map {
  width: 100%;
  height: 120px;
  background-color: red;
}
.button {
  width: 400px;
  margin: 30px auto 0px;
  display: flex;
  justify-content: space-between;
}
.title {
  border: 1px solid rgb(175, 175, 175);
  text-align: center;
  padding: 10px 0px;
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px !important;
}
.tip {
  text-align: center;
  margin: 10px 0px;
  color: red;
}
</style>